import { send } from 'server';

export const getRgConfiguration = () => send({
    ID: 32942,
    responses: [32943, 32944],
    description: 'Get Automatic Withdraw Limits Configuration',
    type: [8]
});

export const getAutomaticWithdrawLimits = () => send({
    ID: 35766,
    responses: [35767, 35768],
    description: 'Get Player Automatic Withdraw Limits'
});
